import React, { Component } from 'react';
import SuppressSecondaryContent from 'utils/SuppressSecondaryContent';
import withLogout from 'utils/withLogout';

class LogoutPage extends Component {
  componentDidMount() {
    this.props.logout && this.props.logout();
  }

  render() {
    return (
      <div className="expand-wrap">
        <SuppressSecondaryContent />
      </div>
    );
  }
}

export default withLogout(LogoutPage);
